// Module
var code = `<form-section-field field-title="'Country'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'country')">
  <select ng-model="\$ctrl.address.countryId"
          ng-disabled="!\$ctrl.editMode"
          ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'country')"
          ng-change="\$ctrl.resetForm()"
          ng-options="entry.id as entry.description for entry in \$ctrl.dict.COUNTRY">
    <option></option>
  </select>
</form-section-field>
<form-section-field field-title="'Province'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'province')">
  <input ng-model="\$ctrl.address.province"
         ng-disabled="!\$ctrl.editMode"
         ng-if="!\$ctrl.editMode || \$ctrl.address.countryId !== \$ctrl.philippinesCountryId"
         ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'province')"
         type="text"
         placeholder="Province"
         maxlength="128">
  <select ng-model="\$ctrl.provinceGeoLocation"
          ng-if="\$ctrl.editMode && \$ctrl.address.countryId === \$ctrl.philippinesCountryId"
          ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'province')"
          ng-change="\$ctrl.setGeoLocationId()"
          ng-options="entry as entry.name for entry in \$ctrl.geoLocations">
  </select>
  <help ng-if="\$ctrl.displayPreviousValue(\$ctrl.address.province)"
        title="Unable to parse geolocation for the province. Current value: {{\$ctrl.address.province}}"></help>
</form-section-field>
<form-section-field field-title="'City'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'city')">
  <input ng-model="\$ctrl.address.city"
         ng-disabled="!\$ctrl.editMode"
         ng-if="!\$ctrl.editMode || \$ctrl.address.countryId !== \$ctrl.philippinesCountryId"
         ng-required="\$ctrl.module === 'branch' ||\$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'city')"
         type="text"
         placeholder="City"
         maxlength="128">
  <select ng-model="\$ctrl.cityGeoLocation"
          ng-if="\$ctrl.editMode && \$ctrl.address.countryId === \$ctrl.philippinesCountryId"
          ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'city')"
          ng-change="\$ctrl.setGeoLocationId()"
          ng-options="entry as entry.name for entry in \$ctrl.provinceGeoLocation.children">
  </select>
  <help ng-if="\$ctrl.displayPreviousValue(\$ctrl.address.city)"
        title="Unable to parse geolocation for the city/municipality. Current value: {{\$ctrl.address.city}}"></help>
</form-section-field>
<form-section-field field-title="'Barangay'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'barangay')">
  <input ng-model="\$ctrl.address.barangay"
         ng-disabled="!\$ctrl.editMode" type="text"
         ng-if="!\$ctrl.editMode || \$ctrl.address.countryId !== \$ctrl.philippinesCountryId"
         ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'barangay')"
         placeholder="Barangay"
         maxlength="128">
  <select ng-model="\$ctrl.barangayGeoLocation"
          ng-if="\$ctrl.editMode && \$ctrl.address.countryId === \$ctrl.philippinesCountryId"
          ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'barangay')"
          ng-change="\$ctrl.setGeoLocationId()"
          ng-options="entry as entry.name for entry in \$ctrl.cityGeoLocation.children">
  </select>
  <help ng-if="\$ctrl.displayPreviousValue(\$ctrl.address.barangay)"
        title="Unable to parse geolocation for the barangay. Current value: {{\$ctrl.address.barangay}}"></help>
</form-section-field>
<form-section-field field-title="'Street'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'street')">
  <input ng-model="\$ctrl.address.street"
         ng-disabled="!\$ctrl.editMode"
         ng-required="\$ctrl.module === 'branch' || \$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'street')"
         type="text"
         placeholder="Street"
         maxlength="256">
</form-section-field>
<form-section-field field-title="'Postal code'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'postal_code')">
  <input ng-model="\$ctrl.address.postalCode"
         ng-disabled="!\$ctrl.editMode"
         ng-required="\$ctrl.propertyConfigService.required(\$ctrl.module, \$ctrl.section, 'postal_code')"
         type="text"
         placeholder="Postal code"
         maxlength="8">
</form-section-field>
<form-section-field field-title="'PSGC Code'" ng-if="\$ctrl.propertyConfigService.visible(\$ctrl.module, \$ctrl.section, 'psgc_code')">
  <input ng-model="\$ctrl.address.psgcCode"
         ng-disabled="true"
         type="text">
</form-section-field>`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/address.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;